import Chessboard from './component';

export default Chessboard;
